/*
 * Dawn's SliderComponent with a 1px tolerance in the visibility check.
 * Cards have fractional widths (e.g. 296.5px), and element.clientWidth rounds
 * them up, so Dawn never saw the last card as fully visible and the "next"
 * arrow never disabled at the end of the carousel.
 */
if (!customElements.get('fhf-slider') && typeof SliderComponent !== 'undefined') {
  customElements.define(
    'fhf-slider',
    class FhfSlider extends SliderComponent {
      isSlideVisible(element, offset = 0) {
        const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
        const right = element.offsetLeft + element.getBoundingClientRect().width;
        return right <= lastVisibleSlide + 1 && element.offsetLeft >= this.slider.scrollLeft - 1;
      }
    }
  );
}
